<template>
    <!-- 基本信息 -->
    <div class="Minister-top information">
        <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">基本信息</div>
        </div>
        <div class="information_content" style="margin-bottom: 20px">
            <div class="information_input">
                <div class="information_Title">
                    <span class="tips">*</span>
                    亮点
                    <el-button type="primary" icon="el-icon-plus" @click="addItem"
                        v-if="(bluePoints.length + 1) != num"></el-button>
                </div>
                <div class="input_el input_span">
                    <div v-for="(key, index) in bluePoints" :key="index" class="newipt d-f" style="margin-bottom:10px;">
                        <el-input ref="customTextarea" class="width97" type="textarea" autosize
                            placeholder="亮点字符不能超过500个" :maxlength="700" v-model="bluePoints[index]"
                            show-word-limit></el-input>
                        <el-button type="danger" icon="el-icon-delete" @click="delItem(index)"
                            v-if="index != 0"></el-button>
                    </div>
                </div>
            </div>
            <div class="information_input mT-10" v-for="(item, index) in titleList" :key="index">
                <div class="information_Title">
                    <span class="tips" v-if="item.required == 1">*</span>
                    {{ item.titleChinese }}
                </div>
                <div class="input_el">
                    <div class="newipt">
                        <el-input v-if="item.name != 'product_description'" class="custom-border-purple width97"
                            autosize :placeholder="'请输入' + item.titleChinese" v-model="formData[index]" show-word-limit>
                        </el-input>
                        <div class="editor-container" v-else>
                            <el-card>
                                <quill-editor v-model="formData[index]" :options="editorOption" @change="
                                    onEditorChange($event, item, index)
                                    "></quill-editor>
                            </el-card>
                        </div>
                    </div>
                </div>
            </div>
            <div class="information_input mT-10">
                <div class="information_Title">产品属性</div>
                <div class="shuxing_box">
                    <div class="item_shuxing" v-for="(item, index) in product_identity" :key="index">
                        <template v-if="item.name != 'externally_assigned_product_identifier' || sellerCommonSetting.eanStatus != 1">
                            <div class="shuxing_label">
                                <span class="shuxing_label_bitian" v-if="item.required == 1">*</span>
                                {{ item.titleChinese }}
                                <p>{{ item.name }}</p>
                            </div>
                            <el-tooltip placement="right-start">
                                <div slot="content" class="el_tip_box">
                                    {{ item.descriptionChinese }}
                                </div>
                                <img :src="urlQueImg" class="item_img" alt />
                            </el-tooltip>
                            <div style="width: 65%" class="mL-10 d-f">
                                <div style="width: 100%" v-for="(items, index) in topShuxingArr[index]" :key="index">
                                    <el-date-picker class="shuxing_input"
                                        v-if="items.oneOfValue != null && items.oneOfValue == 'date'"
                                        v-model="items.publishProduct" :placeholder="'请选择' + items.titleChinese"
                                        format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                    <el-input
                                        :disabled="isChakan || system < 5 || isExternallyAssignedDisabled(items, item)"
                                        v-else-if="items.enumValue == null && items.type == 'string'"
                                        class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                        v-model="items.publishProduct" show-word-limit
                                        :type="items.maxLength == null ? 'input' : 'textarea'"
                                        :maxlength="items.maxLength">
                                    </el-input>
                                    <el-input
                                        :disabled="isChakan || system < 5 || isExternallyAssignedDisabled(items, item)"
                                        v-else-if="items.type == 'integer' || items.type == 'number' && items.enumValue == null"
                                        class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                        v-model="items.publishProduct" show-word-limit type="number"
                                        :max="items.maximum" @input="numberInput(items)" :maxlength="items.maxLength">
                                    </el-input>
                                    <el-select :router="true" class="shuxing_input" v-else
                                        v-model="items.publishProduct"
                                        :disabled="isChakan || system < 5 || isExternallyAssignedDisabled(items, item)"
                                        clearable filterable :placeholder="'请选择' + items.titleChinese">
                                        <el-option v-for="selectItem in items.enumValue" :key="selectItem"
                                            :label="selectItem" :value="selectItem">
                                        </el-option>
                                    </el-select>
                                </div>
                                <el-button
                                    v-if="(!isChakan && system == 5 && item.name == 'externally_assigned_product_identifier')"
                                    :disabled="isChakan || system < 5 || isExternallyAssignedDisabled({}, item)"
                                    style="margin-left: 10px" type="primary" @click="generateEan(item)">
                                    生成Ean
                                </el-button>
                                <el-button v-if="(item.name == 'externally_assigned_product_identifier')"
                                    style="margin-left: 10px" type="primary" @click="checkKeyean(item)">
                                    检查ean
                                </el-button>
                            </div>
                        </template>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
    components: {
        quillEditor
    },
    data() {
        return {
            // 问号图标
            urlQueImg: require('@/assets/images/wenhao.png'),
            bluePoints: [''],
            formData: [],
            editorOption: {
                placeholder: '请输入...',
            },
            product_identity: [],
            topShuxingArr: [],
            num: null,
            isDescriptionValid: true,
            titleList: [{
                name: 'product_description',
                required: 1,
                titleChinese: '描述',
                editorLength: 0
            }, {
                name: 'generic_keyword',
                required: 1,
                titleChinese: '关键词',
            }]
        };
    },
    props: {
        isChakan: {
            type: Boolean,
            default: false,
        },
        system: {
            type: Number,
            default: 5,
        },
        sellerCommonSetting: {}
    },
    methods: {
        getData() {
            // 返回所有当前 data
            return { ...this.$data };
        },
        resetData() {
            // 用 Object.assign 替换 this 上的数据为初始状态
            Object.assign(this.$data, this.$options.data.call(this));
        },
        isExternallyAssignedDisabled(items, item) {
            if (items != undefined) {
                if (item.name === "externally_assigned_product_identifier") {
                    for (let group of this.topShuxingArr) {
                        for (let item of group) {
                            if (item.titleChinese === "免于供应商声明的外部产品标识符" && item.publishProduct === "true") {
                                return true;
                            }
                        }
                    }
                }
            }
            return false; // 默认情况下不禁用
        },
        generateEan(item) {
            let parmamsData = {
                companyId: JSON.parse(localStorage.getItem("role")).company_id,
                count: 1
            }
            let API = Baseurl + 'amazonEan/getUsableEan'
            ajaxPost(API, parmamsData)
                .then((res) => {
                    if (res.data.code == 200) {
                        for (let index = 0; index < item.children.length; index++) {
                            if (item.children[index].property == 'value') {
                                item.children[index].publishProduct = res.data.data[0]
                            }
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                        })
                    }
                })
                .catch((e) => {
                    console.log(e)
                })
        },
        numberInput(items) {
            if (parseFloat(items.publishProduct) > items.maximum) {
                items.publishProduct = items.maximum
            }
        },
        addItem() {
            this.bluePoints.push('')
        },
        delItem(index) {
            this.bluePoints.splice(index, 1)
        },
        // 富文本编辑计算长度
        onEditorChange(event, item, index) {
            // 计算UTF-8字符长度
            const text = event.html.replace(/<[^>]+>/g, '');
            const utf8Length = new TextEncoder().encode(text).length;
            if (utf8Length > 10000) {
                this.$message({
                    type: 'warning',
                    message: '描述内容超过10000个UTF-8字节限制!'
                });
                let tempHtml = event.html;
                while (new TextEncoder().encode(tempHtml.replace(/<[^>]+>/g, '')).length > 10000) {
                    const lastTagEnd = tempHtml.lastIndexOf('>');
                    const lastTagStart = tempHtml.lastIndexOf('<', lastTagEnd);
                    const lastSpacePos = tempHtml.lastIndexOf(' ', lastTagEnd);
                    let cutPosition;
                    if (lastTagStart > lastTagEnd) {
                        cutPosition = lastTagStart;
                    } else if (lastSpacePos > lastTagEnd) {
                        cutPosition = lastSpacePos;
                    } else {
                        cutPosition = tempHtml.length - 1;
                    }
                    
                    tempHtml = tempHtml.substring(0, cutPosition);
                }
                
                this.formData[index] = tempHtml.replace(
                    /((?<=<)|(?<=<\/))(ul|li|h[1-6])/gm,
                    'p'
                );
                this.isDescriptionValid = true;
            } else {
                this.formData[index] = event.html.replace(
                    /((?<=<)|(?<=<\/))(ul|li|h[1-6])/gm,
                    'p'
                );
                this.isDescriptionValid = true;
            }
        },
        // 验证描述内容
        validateDescription() {
            return this.isDescriptionValid;
        },
        // 检查EAN
        checkKeyean(item) {
            // 从产品属性中查找EAN值
            let ean = '';
            for (let index = 0; index < this.product_identity.length; index++) {
                if (this.product_identity[index].name === 'externally_assigned_product_identifier') {
                    // 遍历该属性的所有子项,查找value字段
                    for (let items of this.topShuxingArr[index]) {
                        if (items.property === 'value' && items.publishProduct) {
                            ean = items.publishProduct;
                            break;
                        }
                    }
                    break;
                }
            }

            if (ean) {
                // 打开外部链接并携带 EAN 参数
                window.open(`https://www.barcodelookup.com/${ean}`, '_blank');
            } else {
                this.$message.warning('请先填写EAN码');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../../../AllegroProductAllegro/ozon.less";

.item_img {
    height: 16px;
    width: 16px;
    margin-left: 5px;
    cursor: pointer;
}

.el_tip_box {
    width: 360px;
    font-size: 18px;
    background: rgb(39, 39, 39);
    border-radius: 10px;
    padding: 8px;
    color: whitesmoke;
}

.shuxing_box {
    min-height: 100px;
    background: rgb(238, 238, 238);
    border-radius: 10px;
    width: 88%;
    float: left;
    padding: 10px 0;
    font-size: 16px;

    .item_shuxing {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 4px;

        .shuxing_label {
            width: 20%;
            text-align: right;
            padding: 3px 10px;

            .shuxing_label_bitian {
                color: red;
                margin-right: 4px;
            }
        }

        .shuxing_input {
            width: 100%;
        }

        .shuxing_select {
            width: 100%;
        }

        .shuxing_button {
            width: 30px;
            height: 30px;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgb(255, 183, 82);
            color: white;
            font-weight: 700;
            font-size: 20px;
            margin-left: 10px;
        }
    }
}
</style>